var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNc(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 12,
    viewBox: "0 0 16 12",
    width: 16,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f0f0f0"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "b",
    height: 11.428571,
    rx: 1,
    width: 16
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#094cc7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003cab"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2aad55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#219447"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f65d55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e9443c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fae749"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fbe533"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#262626"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0d0d0d"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "h",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#fff",
    fillRule: "evenodd",
    xlinkHref: "#b"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#a)",
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0h16v3.809524h-16z",
    fill: "url(#c)",
    mask: "url(#h)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 7.619048h16v3.809524h-16z",
    fill: "url(#d)",
    mask: "url(#h)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 3.809524h16v3.809524h-16z",
    fill: "url(#e)",
    mask: "url(#h)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 5.714286,
    fill: "url(#f)",
    mask: "url(#h)",
    r: 2.666667
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7.68898278 4.73234333c-.04404663.0621457-.06993516.13806837-.06993516.22003762 0 .21039419.17055817.38095238.38095238.38095238s.38095238-.17055819.38095238-.38095238c0-.18269067-.12859908-.33534543-.30021234-.37237933.0364515-.01857469.07309074-.03845373.10973615-.05961099.4555168-.26299274.73950697-.6238982.63430994-.80610492-.1051971-.18220671-.55974552-.1167167-1.01526232.14627604-.45551679.26299274-.739507.6238982-.63430991.80610492.06507126.11270672.26381231.13063901.51376888.06567666zm.31101722 3.26765667c-.63118257 0-.76190476-.55151058-.76190476-.76190476 0-.21039419.13072219-.38095238.76190476-.38095238.63118255 0 .76190476.17055819.76190476.38095238 0 .21039418-.13072221.76190476-.76190476.76190476zm0-1.14285714c-.21039421 0-.38095238-.1705582-.38095238-.38095238 0-.21039419.17055817-.38095238.38095238-.38095238s.38095238.17055819.38095238.38095238c0 .21039418-.17055817.38095238-.38095238.38095238zm0-.76190476c-.21039421 0-.38095238-.1705582-.38095238-.38095239 0-.21039418.17055817-.38095238.38095238-.38095238s.38095238.1705582.38095238.38095238c0 .21039419-.17055817.38095239-.38095238.38095239z",
    fill: "url(#g)",
    mask: "url(#h)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNc);
export default __webpack_public_path__ + "static/media/NC.a80987c111f8b2ebaae424eee79ef7b3.svg";
export { ForwardRef as ReactComponent };